import { CLINICAL_FORM_REHABILITA } from './clinicalFormTemplates';

export const REHABILITA_INTAKE_SCHEMA_VERSION = 1;

export function emptyRehabilitaIntake(header = {}) {
  return {
    form_template: CLINICAL_FORM_REHABILITA,
    schema_version: REHABILITA_INTAKE_SCHEMA_VERSION,
    header: {
      folio: '',
      form_date: new Date().toISOString().slice(0, 10),
      clinic_address: '',
      ...header,
    },
    edad: '',
    ap: '',
    a: '',
    af: '',
    ad: '',
    medicamentos: '',
    rx: '',
    historia: '',
    dx: '',
    plan_tx: '',
  };
}

export function mergeRehabilitaIntake(saved) {
  const base = emptyRehabilitaIntake();
  if (!saved || typeof saved !== 'object') return base;
  return {
    ...base,
    ...saved,
    form_template: CLINICAL_FORM_REHABILITA,
    schema_version: REHABILITA_INTAKE_SCHEMA_VERSION,
    header: { ...base.header, ...(saved.header || {}) },
    edad: String(saved.edad ?? '').trim(),
    ap: String(saved.ap ?? '').trim(),
    a: String(saved.a ?? '').trim(),
    af: String(saved.af ?? '').trim(),
    ad: String(saved.ad ?? '').trim(),
    medicamentos: String(saved.medicamentos ?? '').trim(),
    rx: String(saved.rx ?? '').trim(),
    historia: String(saved.historia ?? '').trim(),
    dx: String(saved.dx ?? '').trim(),
    plan_tx: String(saved.plan_tx ?? '').trim(),
  };
}
